module.exports = __webpack_public_path__ + "588348d7bdfcf4ce2e7766d7c7fad9b6.png";